<h3 mat-dialog-title>{{ 'pwaInstallTitle' | transloco }}</h3>

<div mat-dialog-content class="space-y-4">
  <p class="text-sm text-app-body">
    {{ 'pwaInstallIosGuideIntro' | transloco }}
  </p>

  <div class="space-y-4">
    <div class="flex items-center gap-3">
      <div
        class="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-sm font-medium"
      >
        1.
      </div>
      <mat-icon color="primary">language</mat-icon>
      <span>{{ 'pwaInstallIosStepOpenSafari' | transloco }}</span>
    </div>

    <div class="flex items-center gap-3">
      <div
        class="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-sm font-medium"
      >
        2.
      </div>
      <mat-icon color="primary">ios_share</mat-icon>
      <span>{{ 'pwaInstallIosStepTapShare' | transloco }}</span>
    </div>

    <div class="flex items-center gap-3">
      <div
        class="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-sm font-medium"
      >
        3.
      </div>
      <mat-icon color="primary">add_to_home_screen</mat-icon>
      <span>{{ 'pwaInstallIosStepAddToHome' | transloco }}</span>
    </div>

    <div class="flex items-center gap-3">
      <div
        class="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-sm font-medium"
      >
        4.
      </div>
      <mat-icon color="accent">check_circle</mat-icon>
      <span>{{ 'pwaInstallIosStepConfirmAdd' | transloco }}</span>
    </div>
  </div>

  <p class="text-sm text-app-subtle">
    {{ 'pwaInstallIosGuideNote' | transloco }}
  </p>
</div>

<div mat-dialog-actions align="end">
  <button matButton mat-dialog-close>{{ 'close' | transloco }}</button>
</div>
